import { InputText, InputTextProps } from 'primereact/inputtext';
import { useFormContext, Controller, UseControllerProps } from 'react-hook-form';
import React from 'react';
import { Message } from 'primereact/message';

type Props = InputTextProps & {
  inputName: string;
  inputLabel: string;
  containerClass?: string;
  rules?: UseControllerProps['rules'];
};

export default function TextField({ inputName, inputLabel, containerClass = '', rules, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <div className={`field ${containerClass}`}>
      <label htmlFor={inputName}>{inputLabel}</label>
      <Controller
        name={inputName}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <React.Fragment>
            <InputText id={inputName} {...field} className={fieldState.error && 'p-invalid'} {...other} />
            {fieldState.error && (
              <Message id={`error-msg-${inputName}`} severity="error" text={fieldState.error?.message} />
            )}
          </React.Fragment>
        )}
      />
    </div>
  );
}
